import { useRef, useCallback, createContext } from 'react';

type DeferredContextType = {
  addAction: (callback: (arg?: any) => void) => void;
  processActions: (arg?: any) => void;
  clearActions: () => void;
};

const initialState = {
  addAction: () => {},
  processActions: () => {},
  clearActions: () => {},
};

export const DeferredActionContext = createContext<DeferredContextType>(initialState);

export const useDeferredActionContext = (): DeferredContextType => {
  const actions = useRef<Array<(arg?: any) => void>>([]);

  const addAction = useCallback(
    (callback: (arg?: any) => void) => {
      actions.current.push(callback);
    },
    [actions],
  );

  const clearActions = useCallback(
    () => {
      actions.current = [];
    },
    [actions],
  );

  const processActions = useCallback((arg?: any) => {
    try {
      actions.current.forEach((callback) => {
        callback(arg);
      });
      actions.current = [];
    } catch (e) {
      console.error(e);
      actions.current = [];
    }
  },
  [actions]);

  return {
    addAction,
    clearActions,
    processActions,
  };
};
